<template>
  <router-view />
</template>

<script>
import { onMounted, onUnmounted, computed, watch } from 'vue'
import { useStore } from 'vuex'
import { useI18n } from 'vue-i18n'
import '@/plugins/styles'
export default {
  name: 'App',
  setup() {
    const store = useStore()
    const { locale } = useI18n()
    store.dispatch('setting/setSetting')
    const sidebarType = computed(() => store.getters['setting/sidebar_type'])
    const resizePlugin = () => {
      const sidebarResponsive = document.querySelector('[data-sidebar="responsive"]')
      if (window.innerWidth < 1025) {
        if (sidebarResponsive !== null) {
          if (!sidebarResponsive.classList.contains('sidebar-mini')) {
            sidebarResponsive.classList.add('on-resize')
            store.dispatch('setting/sidebar_type', [...sidebarType.value, 'sidebar-mini'])
          }
        }
      } else {
        if (sidebarResponsive !== null) {
          if (sidebarResponsive.classList.contains('sidebar-mini') && sidebarResponsive.classList.contains('on-resize')) {
            sidebarResponsive.classList.remove('on-resize')
            store.dispatch(
              'setting/sidebar_type',
              sidebarType.value.filter((item) => item !== 'sidebar-mini')
            )
          }
        }
      }
    }
    const syncDocumentDirection = (currentLocale) => {
      const isArabic = currentLocale === 'ar'
      document.documentElement.setAttribute('lang', isArabic ? 'ar' : 'en')
      document.documentElement.setAttribute('dir', isArabic ? 'rtl' : 'ltr')
    }
    onMounted(() => {
      window.addEventListener('resize', resizePlugin)
      setTimeout(() => {
        resizePlugin()
      }, 200)
      syncDocumentDirection(locale.value)
    })
    onUnmounted(() => {
      window.removeEventListener('resize', resizePlugin)
    })
    watch(locale, (newLocale) => {
      syncDocumentDirection(newLocale)
    })
  }
}
</script>

<style lang="scss">
@import '@/assets/custom-vue/scss/styles.scss';
</style>
